import { render, staticRenderFns } from "./StartupCardEdit.vue?vue&type=template&id=491137ff"
import script from "./StartupCardEdit.vue?vue&type=script&lang=js"
export * from "./StartupCardEdit.vue?vue&type=script&lang=js"
import style0 from "./StartupCardEdit.vue?vue&type=style&index=0&id=491137ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports